var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 15.9246V18.4246H1.66663V15.9246C1.66663 15.4663 2.04163 15.0913 2.49996 15.0913H17.5C17.9583 15.0913 18.3333 15.4663 18.3333 15.9246Z",
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 9.25732H4.16675V15.0907H5.83341V9.25732Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 9.25732H7.5V15.0907H9.16667V9.25732Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 9.25732H10.8333V15.0907H12.4999V9.25732Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 9.25732H14.1667V15.0907H15.8334V9.25732Z",
    fill: "#292D32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1666 19.0503H0.833252C0.491585 19.0503 0.208252 18.767 0.208252 18.4253C0.208252 18.0836 0.491585 17.8003 0.833252 17.8003H19.1666C19.5083 17.8003 19.7916 18.0836 19.7916 18.4253C19.7916 18.767 19.5083 19.0503 19.1666 19.0503Z",
    fill: "#292D32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8084 4.8835L10.3084 1.8835C10.1417 1.81683 9.85841 1.81683 9.69175 1.8835L2.19175 4.8835C1.90008 5.00016 1.66675 5.34183 1.66675 5.6585V8.42516C1.66675 8.8835 2.04175 9.2585 2.50008 9.2585H17.5001C17.9584 9.2585 18.3334 8.8835 18.3334 8.42516V5.6585C18.3334 5.34183 18.1001 5.00016 17.8084 4.8835ZM10.0001 7.17516C9.30841 7.17516 8.75008 6.61683 8.75008 5.92516C8.75008 5.2335 9.30841 4.67516 10.0001 4.67516C10.6917 4.67516 11.2501 5.2335 11.2501 5.92516C11.2501 6.61683 10.6917 7.17516 10.0001 7.17516Z",
    fill: "#292D32"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.af0628eb8a35645c587b27d4505d2fee.svg";
export { ForwardRef as ReactComponent };